import React from 'react';

import { UserComponent } from 'components/users/User/UserComponent';

import * as Types from 'types';

import { Items } from './Items';

type Props = {
  users: Types.UserCard[];
  isFetching: boolean;
  zeroResultsMessage: string;
  query: string;
};

export const Users: React.FC<Props> = ({
  users,
  isFetching,
  zeroResultsMessage,
  query,
}) => (
  <Items
    isFetching={isFetching}
    zeroResultsMessage={zeroResultsMessage}
    query={query}
  >
    {users.map((user) => {
      return (
        <div
          key={user.id}
          className='col-12 col-lg-3 col-md-4 col-sm-6 mb-gutter'
        >
          <UserComponent user={user} />
        </div>
      );
    })}
  </Items>
);
